import { Component, OnInit } from '@angular/core';
import { BaseReportActionsDialog } from '../base-report-actions-dialog';
import { GaValidateService } from '../../../formly/ga-validate.service';
import { GaEventService } from '../../../services/ga-event.service';
import { IDescribedStringObject, IObject } from '../../../../../type_definitions/datatypes';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../../formly/ga-formly.service';
import { FormattingService } from '../../../services/formatting.service';
import { BPProfilesDataService } from '../../../../main/bp-profiles/bp-profiles-data.service';
import { Override } from '../../../app-decorators';

@Component({
  selector: 'change-bp-action',
  templateUrl: '../../../message/dialogs/default-form-dialog.html'
})
export class ChangeBpActionComponent extends BaseReportActionsDialog implements OnInit {
  private marginSelectionOptions: IDescribedStringObject[] = [{
    id: 'DEFAULT',
    description: 'Overwrite existing margins and SOW with default margins of the new BP'
  }, {
    id: 'KEEP',
    description: 'Keep existing margins and SOW from old BP'
  }];

  private bpField: IExtraFieldConfigurationObject;

  constructor(
    private formlyService: GaFormlyService,
    private formattingService: FormattingService,
    private bpProfilesDataService: BPProfilesDataService,
    eventService: GaEventService,
    validateService: GaValidateService
  ) {
    super(eventService, validateService);
  }

  public ngOnInit(): void {
    super.ngOnInit();

    // init model
    this.model = {
      bp: undefined,
      margin: this.marginSelectionOptions[0]
    };

    // create fields
    this.fields = this.createFields();

    // fill fields
    this.fillFields();
  }

    @Override(BaseReportActionsDialog)
    public getModel(): IObject {
    // return only the companyCountryId of the selected option instead of whole bp profile object
    return {
      companyCountryId: this.model?.bp?.companyCountryId,
      marginSelection: this.model?.margin?.id
    };
  }

  private createFields(): IExtraFieldConfigurationObject[] {
    const labelClass: string = 'col-md-2';
    const valueClass: string = 'col-md-10';

    return [
      this.bpField = this.formlyService.aSelect2('bp', 'BP')
        .isRequired()
        .withLabelClass(labelClass)
        .withValueClass(valueClass)
        .withFormat(this.formattingService.formatBPNicknameCountry)
        .build(),

      this.formlyService.aRadio('margin', 'Margin')
        .withLabelClass(labelClass)
        .withValueClass(`${valueClass} double-space-top`)
        .withFormat(this.formattingService.formatLov)
        .withOptions(this.marginSelectionOptions)
        .build()
    ];
  }

  private fillFields(): void {
    this.formlyService.fillField(
      this.bpField,
      this.bpProfilesDataService.getBPProfiles()
        .catch((error: IObject) => {
          this.error = error?.message;
          this.updateButtonStatus();
        })
    );
  }
}